<template>
  <button 
    v-if="comment" 
    class="gmf-customer-image gmf-clickable" 
    @click.stop="openPostModal(comment.id)"
  >
    <template v-if="isInViewport">
      <div class="gmf-skeleton-image" v-if="loading">
        <div class="gmf-spinner"></div>
      </div>
      <img class="gmf-customer-image-content" alt="Photo shared by customer" :class="{ 'gmf-loaded': ! loading }" loading="lazy" @load="loading = false" :src="comment.content.images?.[0]?.url" />
      <div class="gmf-customer-image-name">
        <Avatar disablePopout :customer="comment.author" defaultPopupTab="comments" />
        <CustomerName :customer="comment.author" />
      </div>
    </template>
  </button>
</template>

<style>
.gmf-customer-image {
  display: flex;
  aspect-ratio: 1;
  position: relative;
  overflow: hidden;
  border: 0;
  background: none;
  padding: 0;
  margin: 0;
  cursor: pointer;
}
.gmf-customer-image-content {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: scale 0.4s ease, opacity 0.6s ease;
  z-index: 0;
  opacity: 0;
  scale: 1.12;
  transform: translateZ(0);
}
.gmf-customer-image-content.gmf-loaded {
  opacity: 1;
}
.gmf-skeleton-image {
  width: 100%;
  height: 100%;
  position: absolute;
  background: var(--gmf-col-gray);
  display: flex;
  align-items: center;
  justify-content: center;
}
.gmf-customer-image-name {
  position: absolute;
  left: var(--gmf-p-3);
  bottom: var(--gmf-p-3);
  display: flex;
  align-items: center;
  gap: var(--gmf-p-3);
}
.gmf-customer-image-name .gmf-avatar-component {
  text-shadow: none;
}
.gmf-customer-image::after {
  content: '';
  display: block;
  background: linear-gradient(0deg, rgba(0, 0, 0, 0.5), transparent 50px);
  position: absolute;
  inset: 0;
  pointer-events: none;
}
.gmf-customer-image .gmf-customer-name {
  z-index: 1;
  width: 100%;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  --gmf-col-name: var(--gmf-col-white);
  --gmf-link-color: var(--gmf-col-white);
}
.gmf-customer-image-name {
  pointer-events: none;
  white-space: nowrap;
  text-overflow: ellipsis;
  position: absolute;
  left: var(--gmf-p-3);
  right: var(--gmf-p-3);
  bottom: var(--gmf-p-3);
  display: flex;
  align-items: center;
  gap: var(--gmf-p-3);
  text-shadow: 0px 0px 3px rgba(0,0,0,.4);
}
.gmf-customer-image .gmf-avatar {
  width: 32px;
  height: 32px;
  border: 0;
  box-sizing: content-box;
  z-index: 1;
  flex-shrink: 0;
}

.gmf-customer-image:hover .gmf-customer-image-content {
  scale: 1.01;
}

.gmf-spinner {
  width: 40px;
  height: 40px;
  border: 4px solid rgba(255, 255, 255, 0.3);
  border-radius: 50%;
  border-top-color: var(--gmf-col-white);
  animation: gmf-spin 1s linear infinite;
}

@keyframes gmf-spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
</style>

<script>
import Avatar from '@/components/Avatar';
import CustomerName from '@/components/CustomerName';
import openPostModal from '@/widgets/PostModal/openPostModal';

export default {
  name: 'CustomerImage',
  props: {
    'comment': {
      type: Object,
      default: null
    },
    'useInViewport': {
      type: Boolean,
      default: false
    },
    'intersectionObserverRoot': {
      type: Object,
      default: null
    }
  },
  components: { Avatar, CustomerName },
  data () {
    return {
      loading: true,
      isInViewport: true,
      intersectionObserver: null
    };
  },
  methods: {
    openPostModal,
  },
  mounted() {
    if (this.useInViewport) {
      this.intersectionObserver = new IntersectionObserver(
          (entries) => {
            this.isInViewport = entries[0].isIntersecting;
        },
        {
          rootMargin: '250px 0px',
          root: this.intersectionObserverRoot
        }
      );

      this.intersectionObserver.observe(this.$el);
    }
  },
  beforeUnmount() {
    // Cleanup
    if (this.useInViewport) {
      this.intersectionObserver.disconnect();
    }
  }
};
</script>
